import { type FantasyPosition, type SupportedNetworkName } from '@pkg/types';

import { type CompetitionCollectionStatus, type WishlistLineupItem } from '@app/client';

import { type ResourceId } from '../general';
import { type WishlistCollectionParam, type WishlistType } from '../wishlists';

export enum GAME_ROUTES {
    Lineup = '',
    Leaderboard = 'leaderboard',
    Team = 'team',
    About = 'about',
}

export interface Item {
    id: ResourceId;
    item: WishlistCollectionParam;
}

export interface LineupItemPayload {
    competitionId: ResourceId;
    Collection: { slug: string };
    network: SupportedNetworkName;
    quantity?: number;
    confirmed?: boolean;
    dynamicsOn?: boolean;
    position?: FantasyPosition;
    wishlistId?: ResourceId;
    wishlistName?: string;
    teamId?: ResourceId;
}

export interface LineupItem {
    competition_id: ResourceId;
    Collection: { slug: string };
    network: SupportedNetworkName;
    quantity?: number;
    confirmed?: boolean;
    position?: FantasyPosition;
    wishlist_id?: ResourceId;
    wishlist_name?: string;
    team_id?: ResourceId;
    created_at?: string;
    updated_at?: string;
}

export interface LineupItemResponse extends Omit<LineupItem, 'Collection'> {
    item: Item;
    initial_value?: number;
    conversion_rate?: number;
    initial_value_usd?: number;
    initial_value_singular?: number;
    version?: number;
    realized_profit?: number;
    realized_value?: number;
    realized_value_usd?: number;
    validated?: boolean;
}

export type AddItemResponse = { item: LineupItemResponse; competition_id: ResourceId; wishlist_id: ResourceId };

export interface FantasyLineupItem extends Partial<WishlistLineupItem> {
    slug: string;
    chain: SupportedNetworkName;
    quantity?: number;
    isValid?: boolean;
    confirmed?: boolean;
    status?: CompetitionCollectionStatus;
    tooltipMessage?: string;
    floorPrice?: string;
}

export interface WishlistAuditQuery {
    competition_id?: string;
    wishlist_id?: string;
    user_id?: string;
}
export interface WishlistAudit {
    id: string;
    name: string;
    user_id: string;
    private: boolean;
    wishlist_type: WishlistType;
    follower_count: number;
    contents_modified_at: string;
    created_at: string;
    updated_at: string;
    budget_usd: number;
    competition_id?: string;
    team_id?: string;
    op: string;
    stamp: string;
}

export interface WishlistItemAuditQuery extends WishlistAuditQuery {
    wishlist_item_id?: string;
}

export interface WishlistItemAudit extends WishlistAudit {
    item: Item['item'];
    network: SupportedNetworkName;
    wishlist_id: string;
    quantity: number;
    version: number;
    created_at: string;
    updated_at: string;
    position?: FantasyPosition;
    initial_value?: number;
    conversion_rate?: number;
    initial_value_usd?: number;
    initial_value_singular?: number;
    realized_profit?: number;
    realized_value?: number;
    realized_value_usd?: number;
    confirmed?: boolean;
    validated: boolean;
    op: string;
    stamp: string;
}
